import union from 'lodash/union';
import {
	CLAUSE_TYPE_TERMINAL,
	OPERAND_TYPE_KEYWORD,
	OPERAND_TYPE_LIST,
	OPERAND_TYPE_VALUE,
	type Operand,
	type TerminalClause,
} from '@atlaskit/jql-ast';

export const getOperands = (operand: Operand): string[] => {
	switch (operand?.operandType) {
		case OPERAND_TYPE_KEYWORD:
		case OPERAND_TYPE_VALUE: {
			return [operand.value];
		}
		case OPERAND_TYPE_LIST: {
			return union(...operand.values.map((operandValue) => getOperands(operandValue)));
		}
		default: {
			return [];
		}
	}
};

export const getSelectedValuesForField = (clauses: TerminalClause[] | undefined) => {
	if (!clauses || clauses.length === 0) {
		return [];
	}

	const [clause] = clauses;

	if (clause.clauseType !== CLAUSE_TYPE_TERMINAL) {
		return [];
	}

	const { operand } = clause;

	if (!operand) {
		return [];
	}

	return getOperands(operand);
};
